export default "__VITE_ASSET__Oq$nAN7x__"